import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-ipsa",
  templateUrl: "./ipsa.component.html",
  styleUrls: ["./ipsa.component.scss"],
})
export class IpsaComponent implements OnInit {
  constructor(public router: Router) {
    const pageAction = JSON.parse(
      sessionStorage.getItem("userPermission") || "[]",
    );
    const currentBaseProgramForm = this.getCurrentProgramFormMethod(
      pageAction[0],
    );

    this.allowedAction = pageAction[0].authenicationJson.filter((el: any) => {
      if (el?.model === currentBaseProgramForm.model) {
        return el;
      }
    });
    this.isShowReport = this.allowedAction.length
      ? this.allowedAction[0].authentication.find(
          (auth: any) =>
            ["report", "submissionlist"].includes(auth.key) && auth.isAction,
        )
      : false;
  }
  isShowReport = false;

  formJson: any = [
    {
      id: 1,
      formName: "Introduction to the PRISM",
      image: "../../../assets/images/ipsa-icon.svg",
    },
    {
      id: 2,
      formName: "PRISM V1.0 Forms",
      image: "../../../assets/images/ipsaForms-icon.svg",
    },
    {
      id: 3,
      formName: "PRISM Dashboard",
      image: "../../../assets/images/ipsaDashboard-icon.svg",
    },
  ];

  baseFormModule: string[] = ["ipsa"];
  allowedAction: any = [];

  ngOnInit(): void {}

  toggle(data: any): void {
    if (data.id === 3) {
      this.router.navigate(["/prism-dashboard"]);
    } else if (data.id === 1) {
      this.router.navigate(["/prism-intro"]);
    } else {
      this.router.navigate(["/prism-forms"]);
    }
  }

  goToPrismReport(): void {
    this.router.navigate(["/prism-report"]);
  }

  getCurrentProgramFormMethod(data: any): any {
    let getCurrentTab: any = null;

    this.baseFormModule.some((el: any) => {
      getCurrentTab = data.authenicationJson.find((e: any) => {
        return (
          e.model === el &&
          (e.isAction ||
            e.is_checked ||
            (e.authentication &&
              e.authentication.some((inside: any) => inside.isAction)))
        );
      });

      return getCurrentTab !== undefined;
    });

    return getCurrentTab;
  }
}
